import { render, staticRenderFns } from "./BaseDataCard.vue?vue&type=template&id=1d1a5af4"
import script from "./BaseDataCard.vue?vue&type=script&lang=js"
export * from "./BaseDataCard.vue?vue&type=script&lang=js"
import style0 from "./BaseDataCard.vue?vue&type=style&index=0&id=1d1a5af4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports